<div class="prompt-container">
  <h3-selectable-object [objectIndex]="prompt.index">
    <div class="prompt-content">
      @if (image) {
        <img class="asset-container" [src]="assetUrl$ | async" />
      } @else if (video) {
        <video
          class="asset-container"
          [src]="assetUrl$ | async"
          controls
          controlslist="nodownload"
        ></video>
      }
      <span *ngIf="text" class="text subtitle-02">
        {{ text.tags.text }}
      </span>
    </div>
  </h3-selectable-object>
</div>
<div class="response-container">
  <h3-response-editor [responseObject]="response"></h3-response-editor>
</div>
